module.exports = __webpack_public_path__ + "img/niels.96ba25d7.png";